import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import Loader from './../../components/Loader/Loader'
import Products from '../../components/FeedingGuidelines/Products/Products';
import fetchFeedingGuidelinesProductsAction from './../../store/actions/fetch/fetchFeedingGuidelinesProductsAction';
import * as actionTypes from './../../store/actions/feedingGuidelinesProductsAction';

import * as pdfOutputAction from './../../store/actions/pdfOutputAction';
import domtoimage from 'dom-to-image';
import OnImagesLoaded from 'react-on-images-loaded';

class FeedingGuidelinesProducts extends Component {

  componentDidMount() {
    const {fetchData} = this.props;
    fetchData(this.props.output.products, this.props.amounts);
  }

  componentDidUpdate() {
  }

  doScreenShot() {
    const {screenshots}  = this.props;
    const el = document.getElementById('fc-screenshot-feeding-guidelines-products');
    const {setScreenShot, onScreenshotError} = this.props;
    if (el){
      domtoimage.toPng(el)
        .then(function (dataUrl) {
          if (screenshots && screenshots['fc-screenshot-feeding-guidelines-products'] !== dataUrl){
            setScreenShot(dataUrl);
          }
        })
        .catch(function () {
          onScreenshotError();
        });
    } else {
      onScreenshotError();
    }
  }

  render() {
    const { data, pending, ready, error, amounts, mealsPerDay, wetFoodAmountLabel, dataDer } = this.props;
    const animalState = this.props.output.casuistic || null;

    if(pending || !ready || !data) return (
      <Loader/>
    );

    return (
      <OnImagesLoaded
        onLoaded={this.doScreenShot.bind(this)}
        onTimeout={this.doScreenShot.bind(this)}
        timeout={7000}
      >
        <Products
          data={data}
          amounts={amounts}
          mealsPerDay={mealsPerDay}
          animalState={animalState}
          wetFoodAmountLabel={wetFoodAmountLabel}
          der={dataDer}
        />
      </OnImagesLoaded>
    );
  }
}

const mapStateToProps = state => {

  let wetFoodAmountLabel = null;

  if (typeof state?.dailyWetReducer?.amounts?.wetPortionLabel != "undefined"
    && typeof state?.dailyWetReducer?.amounts?.wetPackage  != "undefined") {
    wetFoodAmountLabel = state?.dailyWetReducer?.amounts?.wetPortionLabel + " " + state?.dailyWetReducer?.amounts?.wetPackage;
  }

  return {
    data: state.feedingGuidelinesProductsReducer.data,
    pending: state.feedingGuidelinesProductsReducer.pending,
    ready: state.feedingGuidelinesProductsReducer.ready,
    error: state.feedingGuidelinesProductsReducer.error,
    screenshots: state.pdfOutputReducer.images,
    amounts: state.dailyWetReducer.amounts,
    mealsPerDay: state.petInfoReducer.mealsPerDay,
    dataDer: state.calculateDerReducer.data,
    wetFoodAmountLabel: wetFoodAmountLabel,
  }
};


const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchFeedingGuidelinesProductsAction
      },
      dispatch,
    ),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    setScreenShot: (data) => dispatch({
      type: pdfOutputAction.ADD,
      key: 'fc-screenshot-feeding-guidelines-products',
      data: data,
    }),
    onScreenshotError: () => dispatch({
      type: pdfOutputAction.SCREENSHOT_ERROR,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedingGuidelinesProducts);
